import React, { Component } from 'react';
import { connect } from 'react-redux';
import Heading from '../../Component/UI/Heading';

class BubbleMap extends Component {
  constructor(props) {
    super(props);

    this.pdfExportComponent = React.createRef();

    this.state = {
      showMainPage: true,
      showFilter: false,
      showValue: '',
      showTabView: 2,
      showModalDownload: false
    };
  }

  componentDidMount() { }

  hexToRgbA = (hex, opacity) => {
    let c;

    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');

      if (c.length === 3) {
        c = [
          c[0], c[0],
          c[1], c[1],
          c[2], c[2]
        ];
      }

      c = '0x' + c.join('');

      return (
        'rgba(' +
        [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
        ',' +
        opacity +
        ')'
      );
    }

    return hex;
  };

  render() {
    const { list = [] } = this.props;

    // Find highest count
    const maxCount = Math.max(
      ...list.map(item => Number(item.count) || 0),
      1
    );

    return (
      <>
        <div className="bg-white">

          <Heading
            className="text-xl pb-5"
            title="Dominant Theme Frequency"
          />

          <div className="md:p-6 p-4 bg-white border border-[#D1D5DB] shadow-sm rounded-xl">

            {list.map((item, index) => {

              const count = Number(item.count) || 0;

              // Calculate bar width based on highest count
              const barWidth = (count / maxCount) * 100;

              return (
                <div
                  key={index}
                  className="flex items-center gap-4 mb-4 last:mb-0"
                >

                  {/* Dimension Name */}
                  <div className="w-36 text-lg font-medium text-black truncate">
                    {item.dimension}
                  </div>

                  {/* Progress Bar */}
                  <div className="flex-1 h-7 bg-gray-100 overflow-hidden rounded-md">

                    <div
                      className="h-full rounded-md transition-all duration-500"
                      style={{
                        width: `${barWidth}%`,
                        background: this.hexToRgbA(
                          item.colorCode,
                          '0.6'
                        )
                      }}
                    />

                  </div>

                  {/* Count */}
                  <div
                    className="min-w-[40px] text-center text-sm font-medium px-2 py-1.5 rounded-full"
                    style={{
                      background: this.hexToRgbA(
                        item.colorCode,
                        '0.2'
                      )
                    }}
                  >
                    {item.count}
                  </div>

                </div>
              );
            })}

            {/* No Data */}
            {list.length === 0 && (
              <div className="text-center text-gray-500 py-8">
                No data available
              </div>
            )}

          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  const { users, dashboard } = state;

  return {
    loggingIn,
    users,
    dashboard
  };
}

export default connect(mapStateToProps)(BubbleMap);